var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25C3.58375 0.25 0.125 2.0625 0.125 4.375C0.125 4.40375 0.1275 4.4325 0.12875 4.46C0.1275 4.47375 0.125 4.48625 0.125 4.5V11.75C0.125 11.9575 0.2925 12.125 0.5 12.125C0.7075 12.125 0.875 11.9575 0.875 11.75V6.16125C2.075 7.50125 4.6025 8.425 7.625 8.49625V15.5C7.625 15.7075 7.7925 15.875 8 15.875C8.2075 15.875 8.375 15.7075 8.375 15.5V8.495C11.3975 8.42375 13.925 7.5 15.125 6.16V11.75C15.125 11.9575 15.2925 12.125 15.5 12.125C15.7075 12.125 15.875 11.9575 15.875 11.75V4.5C15.875 4.48625 15.8725 4.47375 15.8713 4.46C15.8725 4.43125 15.875 4.40375 15.875 4.375C15.875 2.0625 12.4163 0.25 8 0.25ZM8 7.75C4.1375 7.75 0.875 6.205 0.875 4.375C0.875 2.545 4.1375 1 8 1C11.8625 1 15.125 2.545 15.125 4.375C15.125 6.205 11.8625 7.75 8 7.75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.444444
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlTable);
export default __webpack_public_path__ + "static/media/fl-table.27f30aac9f3e7beebfb3665b38a646ee.svg";
export { ForwardRef as ReactComponent };